<template>
  <a v-if="link" :href="link" target="_blank">
    <span class="title">{{ title }}</span>
  </a>
  <span v-else class="title">{{ title }}</span>
</template>

<script>
export default {
  name: 'TitleComponent',
  props: ['title', 'link'],
};
</script>

<style scoped lang="scss">
.title {
  color: black;
}
a {
  text-decoration: none;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
}
</style>
